import { Expression } from "@dooboostore/core";
class Intent {
  constructor(uri, data) {
    this.uri = uri;
    this.data = data;
    this.sessionData = /* @__PURE__ */ new Map();
    if (typeof uri === "string") {
      const match = uri.match(/^Symbol\.for\((.+)\):\/(.*)$/);
      if (match) {
        const symbol = Symbol.for(match[1]);
        this.uri = {
          symbol,
          uri: `/${match[2]}`
        };
      }
    }
  }
  get symbols() {
    if (typeof this.uri === "object" && "symbol" in this.uri) {
      return Array.isArray(this.uri.symbol) ? this.uri.symbol : [this.uri.symbol];
    }
    return void 0;
  }
  get types() {
    if (typeof this.uri === "object" && "type" in this.uri) {
      return this.uri.type;
    }
    return void 0;
  }
  get scheme() {
    if (typeof this.uri === "string") {
      const parts = this.uri.split("://");
      if (parts.length > 1) {
        return parts[0];
      }
      return void 0;
    } else {
      return void 0;
    }
  }
  get paths() {
    if (typeof this.uri === "object" && "type" in this.uri && "target" in this.uri) {
      return [String(this.uri.target)];
    }
    return this.pathname.split("/") ?? [];
  }
  get fullPath() {
    if (typeof this.uri === "object" && "type" in this.uri && "target" in this.uri) {
      return `/${String(this.uri.target)}`;
    }
    const uri = typeof this.uri === "string" ? this.uri : this.uri.uri;
    const paths = uri.split("://");
    return paths[paths.length >= 2 ? 1 : 0] ?? "";
  }
  get pathname() {
    const paths = this.fullPath.split("?");
    return paths[0];
  }
  get query() {
    const paths = this.fullPath.split("?");
    return paths[1] ?? "";
  }
  getQueryParamDecodeURI(key) {
    const p = this.queryParamsDecodeURI;
    if (key) {
      return p[key];
    } else {
      return p;
    }
  }
  getQueryParamDecodeURIFirst(key) {
    const param = this.getQueryParamDecodeURI(key);
    if (Array.isArray(param)) {
      return param[0];
    } else {
      return param;
    }
  }
  getQueryParam(key) {
    const p = this.queryParams;
    if (key) {
      return p[key];
    } else {
      return p;
    }
  }
  getQueryParamFirst(key) {
    const param = this.getQueryParam(key);
    if (Array.isArray(param)) {
      return param[0];
    } else {
      return param;
    }
  }
  get queryParams() {
    const param = {};
    this.query.split("&")?.forEach((it) => {
      const a = it.split("=");
      if (param[a[0]]) {
        if (Array.isArray(param[a[0]])) {
          param[a[0]].push(a[1]);
        } else {
          param[a[0]] = [param[a[0]], a[1]];
        }
      } else {
        param[a[0]] = a[1];
      }
    });
    return param;
  }
  get queryParamsDecodeURI() {
    const params = this.queryParams;
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const param = params[key];
        if (Array.isArray(param)) {
          params[key] = param.map((p) => decodeURIComponent(p));
        } else {
          params[key] = decodeURIComponent(param);
        }
      }
    }
    return params;
  }
  getPathnameData(urlExpression) {
    return Expression.Path.pathNameData(this.pathname, urlExpression);
  }
  get isSymbolScheme() {
    return this.symbols !== void 0;
  }
}
export {
  Intent
};
//# sourceMappingURL=Intent.js.map
